import React from 'react';
import Layout from '../Components/Layout/Layout';
import Signup from '../Components/Signup/Signup';

function SignupPage() {
  return (
    <Layout hideHeader hideFooter>
      <Signup />
    </Layout>
  );
}

export default SignupPage;
